import { GoodPracticeFilterBar } from "./components/GoodPracticeFilterBar";

export default GoodPracticeFilterBar;